{
  "reminder": {
    "overdue": "No audit log checkpoint has been printed in the last day. Print one and file it — it shows afterwards that the log has not been changed.",
    "never": "No audit log checkpoint has been printed on this box. Print one and file it — it shows afterwards that the log has not been changed.",
    "last": "Last audit log checkpoint: {printedAt}.",
    "print": "Print checkpoint"
  },
  "sheet": {
    "title": "Audit log checkpoint",
    "explanation": "This sheet names one row in the audit log and its hash. File it away from the box. If the log were changed afterwards the hash would no longer match, and the command below shows it.",
    "seq": "Sequence number",
    "hash": "Hash",
    "fingerprint": "Fingerprint",
    "anchoredAt": "Row written",
    "printedAt": "Sheet printed",
    "commandHeading": "Verifying against this sheet",
    "commandExplanation": "Run by the technician on the box. Both values are already filled in and must not be changed.",
    "fingerprintNote": "The fingerprint is the first characters of the hash, for comparing by eye. The hash is what counts.",
    "notVerified": "This sheet is not a verification of the log. It is a fixed point a later verification starts from.",
    "failed": "The checkpoint could not be fetched. Try again.",
    "retry": "Try again",
    "intro": "The sheet is produced and printed when you press the button. Only then does it count as printed — going back before that writes nothing to the log.",
    "produce": "Print checkpoint",
    "producing": "Producing the checkpoint …",
    "back": "Back to the ward list"
  }
}
